module.exports = __webpack_public_path__ + "img/hauswirtschaft_r_h_7170.98a34d72.jpg";